import 'shepherd.js/dist/css/shepherd.css';

import Shepherd from 'shepherd.js';

import styles from './dashboard-tour.module.scss';
import { TFunction } from 'next-i18next';
export function dashboardTour(t: TFunction, tc: TFunction) {
    const burgerMenuButton = document.querySelector('.burgerMenuButton');

    const tour = new Shepherd.Tour({
        useModalOverlay: true,
        defaultStepOptions: {
            cancelIcon: {
                enabled: true,
            },
            classes: styles.shepherdThemeCustom,
            scrollTo: { behavior: 'smooth', block: 'center' },
            highlightClass: styles.customHighlight,
        },
    });

    tour.addStep({
        title: `${t('myUtmb.shepherd.intro.title')}`,
        text: `${t('myUtmb.shepherd.intro.description')}`,
        buttons: [
            {
                action() {
                    if (burgerMenuButton instanceof HTMLElement) burgerMenuButton.click();
                    return this.cancel();
                },
                classes: styles.shepherdButtonBack,
                text: `${t('myUtmb.shepherd.button.close')}`,
            },
            {
                action() {
                    return this.next();
                },
                classes: styles.shepherdButtonNext,
                text: `${t('myUtmb.shepherd.button.next')}`,
            },
        ],
    });
    if (burgerMenuButton instanceof HTMLElement)
        tour.addStep({
            title: `${t('myUtmb.shepherd.burger.title')}`,
            text: `${t('myUtmb.shepherd.burger.description')}`,
            attachTo: {
                element: '.burgerMenuButton',
                on: 'bottom',
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: styles.shepherdButtonBack,
                    text: `${t('myUtmb.shepherd.button.previous')}`,
                },
                {
                    action() {
                        burgerMenuButton.click();
                        return this.next();
                    },
                    classes: styles.shepherdButtonNext,
                    text: `${t('myUtmb.shepherd.button.next')}`,
                },
            ],
        });

    tour.addStep({
        title: `${tc('myUtmb.navigation.dashboard')}`,
        text: `${t('myUtmb.shepherd.dashboard')}`,
        attachTo: {
            element: '.my-dashboard',
            on: 'bottom',
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: styles.shepherdButtonBack,
                text: `${t('myUtmb.shepherd.button.previous')}`,
            },
            {
                action() {
                    return this.next();
                },
                classes: styles.shepherdButtonNext,
                text: `${t('myUtmb.shepherd.button.next')}`,
            },
        ],
    });

    tour.addStep({
        title: `${tc('myUtmb.navigation.achievements')}`,
        text: `${t('myUtmb.shepherd.achievements')}`,
        attachTo: {
            element: '.my-achievements',
            on: 'bottom',
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: styles.shepherdButtonBack,
                text: `${t('myUtmb.shepherd.button.previous')}`,
            },
            {
                action() {
                    return this.next();
                },
                classes: styles.shepherdButtonNext,
                text: `${t('myUtmb.shepherd.button.next')}`,
            },
        ],
    });

    tour.addStep({
        title: `${tc('myUtmb.navigation.registrations')}`,
        text: `${t('myUtmb.shepherd.registrations')}`,
        attachTo: {
            element: '.my-registrations',
            on: 'bottom',
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: styles.shepherdButtonBack,
                text: `${t('myUtmb.shepherd.button.previous')}`,
            },
            {
                action() {
                    return this.next();
                },
                classes: styles.shepherdButtonNext,
                text: `${t('myUtmb.shepherd.button.next')}`,
            },
        ],
    });

    tour.addStep({
        title: `${tc('myUtmb.navigation.rewards')}`,
        text: `${t('myUtmb.shepherd.rewards')}`,
        attachTo: {
            element: '.my-rewards',
            on: 'bottom',
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: styles.shepherdButtonBack,
                text: `${t('myUtmb.shepherd.button.previous')}`,
            },
            {
                action() {
                    return this.next();
                },
                classes: styles.shepherdButtonNext,
                text: `${t('myUtmb.shepherd.button.next')}`,
            },
        ],
    });

    tour.addStep({
        title: `${tc('myUtmb.navigation.information')}`,
        text: `${t('myUtmb.shepherd.information')}`,
        attachTo: {
            element: '.my-information',
            on: 'bottom',
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: styles.shepherdButtonBack,
                text: `${t('myUtmb.shepherd.button.previous')}`,
            },
            {
                action() {
                    return this.next();
                },
                classes: styles.shepherdButtonNext,
                text: `${t('myUtmb.shepherd.button.next')}`,
            },
        ],
    });

    tour.addStep({
        title: `${tc('myUtmb.navigation.roadToUtmb')}`,
        text: `${t('myUtmb.shepherd.roadToUtmb')}`,
        attachTo: {
            element: '.my-road-to-utmb',
            on: 'bottom',
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: styles.shepherdButtonBack,
                text: `${t('myUtmb.shepherd.button.previous')}`,
            },
            {
                action() {
                    if (burgerMenuButton instanceof HTMLElement) burgerMenuButton.click();
                    return this.next();
                },
                classes: styles.shepherdButtonNext,
                text: `${t('myUtmb.shepherd.button.close')}`,
            },
        ],
    });

    tour.start();
}
